export const CONNECTOR_STATUSES = [
    {
        translationCode: 'lblOnline',
        value: 'Online',
        chargerTypes: ['CAPI', 'OCPP'],
    },
    {
        translationCode: 'lblConnectorAvailableStatus',
        value: 'Available',
        chargerTypes: ['CAPI', 'OCPP'],
    },
    {
        translationCode: 'lblChargePointConnectedState',
        value: 'Connected',
        chargerTypes: ['CAPI'],
    },
    {
        translationCode: 'lblConnectorPreparingStatus',
        value: 'Preparing',
        chargerTypes: ['OCPP'],
    },
    {
        translationCode: 'lblConnectorChargingStatus',
        value: 'Charging',
        chargerTypes: ['CAPI', 'OCPP'],
    },
    {
        translationCode: 'lblConnectorPausedByEvStatus',
        value: 'SuspendedEV',
        chargerTypes: ['OCPP'],
    },
    {
        translationCode: 'lblConnectorPausedByChargerStatus',
        value: 'SuspendedEVSE',
        chargerTypes: ['OCPP'],
    },
    {
        translationCode: 'lblConnectorFinishingStatus',
        value: 'Finishing',
        chargerTypes: ['OCPP'],
    },
    {
        translationCode: 'lblConnectorNotAvailableStatus',
        value: 'Unavailable',
        chargerTypes: ['CAPI', 'OCPP'],
    },
    {
        translationCode: 'lblConnectorErrorStatus',
        value: 'Faulted',
        chargerTypes: ['CAPI', 'OCPP'],
    },
    {
        translationCode: 'lblOffline',
        value: 'Offline',
        chargerTypes: ['CAPI', 'OCPP'],
    },
]
